import slugify from 'slugify';

const SLUGIFY_OPTS = {
  strict: true
};

export const slugifyName = (name) => slugify(name.toLowerCase(), SLUGIFY_OPTS);

const SLUG_SEPARATOR = '_';

const trimSlug = (name, limitChars) => {
  if (name.length <= limitChars) {
    return name;
  }

  const trimmedName = name.substring(0, limitChars);

  if (trimmedName.lastIndexOf(SLUG_SEPARATOR) === -1) {
    return trimmedName;
  }
  return trimmedName.substring(0, trimmedName.lastIndexOf(SLUG_SEPARATOR));
};

export const slugifyForURL = (name, limitChars) => {
  let parts = (name || '').split(' ').filter((part) => part.length > 0);

  parts = parts.map((part) => slugify(part, SLUGIFY_OPTS).trim());

  const slugifiedName = parts.join(SLUG_SEPARATOR);

  if (limitChars) {
    return trimSlug(slugifiedName, limitChars);
  }

  return slugifiedName;
};
